import { Middleware } from 'redux';
import { updateUserData, selectUserCoreInfo } from 'store/modules/users/authReducer';
import { getUserPortfolio } from 'store/modules/profile/profileReducer';

declare global {
    interface Window {
      hj: (event: string, id: any, data: any) => void;
    }
  }

export const hotjarMiddleware: Middleware = store => next => action => {

    if (action.type === getUserPortfolio.type) {
        const userCore = selectUserCoreInfo(store.getState());

        if(userCore) {
            window.hj('identify', userCore.id, {
                email: userCore.email
            });
        }
    }

    return next(action);
}